import { render } from "./Graph.vue?vue&type=template&id=23afb180"
import script from "./Graph.vue?vue&type=script&lang=js"
export * from "./Graph.vue?vue&type=script&lang=js"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__